import React, { Suspense } from 'react'
import { makeStyles, createStyles, Box, fade } from '@material-ui/core'
import { SITE_MATE_DATA } from 'src/utils/constant'
import { ReactComponent as HelpIcon } from 'src/mobile/assets/icons/help.svg'
import { ReactComponent as VectorIcon } from 'src/mobile/assets/icons/Home_Vector.svg'
import { ReactComponent as ViewAllIcon } from 'src/mobile/assets/icons/Home_all.svg'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Header from 'src/mobile/components/Homepage/Header'
import { useSelector } from 'react-redux'
import { useImageTranslation } from 'src/hooks'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core'
import 'swiper/swiper-bundle.min.css'
import 'swiper/components/pagination/pagination.min.css'
import 'swiper/components/navigation/navigation.min.css'
import Loading from 'src/mobile/components/Loading'
// import ProductSwiper from 'src/components/ProductSwiper'
import ProductSwiper2 from 'src/mobile/components/Homepage/ProductSroll'
import { buttonClick } from 'src/utils/trackingCode'
import { Helmet  } from 'react-helmet'

SwiperCore.use([Autoplay, Pagination, Navigation])
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
    homepageBanner: {
      borderRadius: theme.spacing(1.5),
      display: 'block',
      width: '100%',
      margin: '0 auto',
      cursor: 'pointer',
    },
    homepageBannerText: {
      fontSize: 16,
      marginTop: theme.spacing(1),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      lineClamp: 2,
      WebkitBoxOrient: 'vertical',
    },
    cardHeader: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(1.5),
      borderRadius: 6,
      boxShadow: `0px 3px 4px rgba(68, 80, 123, 0.1)`,
    },
    cardAvatar: {
      marginRight: theme.spacing(1.5),
    },
    avatarIcon: {
      '& path': {
        fill: theme.palette.primary.contrastText,
      },
    },
    tips: {
      background: `linear-gradient(190deg, ${fade(theme.palette.secondary.main, 0.07)} 17%, ${fade(
        theme.palette.secondary.contrastText,
        0.16,
      )} 76%)`,
    },
    radioOnIcon: {
      height: '80%',
      width: 'auto',
      position: 'absolute',
      right: 0,
      bottom: '-5%',
    },

    swiperWrapper: {
      // width: '100%',
      // borderRadius: 0,
      '& .swiper-button-prev,.swiper-button-next': {
        '&:after': {
          fontSize: theme.spacing(5),
          color: fade(theme.palette.common.black, 0.25),
          [theme.breakpoints.down('xs')]: {
            fontSize: theme.spacing(3),
          },
        },
      },
      '& .swiper-button-prev': {
        left: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
          left: theme.spacing(0.8),
        },
      },
      '& .swiper-button-next': {
        right: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
          right: theme.spacing(0.8),
        },
      },
      WebkitBackfaceVisibility: 'hidden',
      '& .swiper-slide': {
        width: '100%',
        WebkitBackfaceVisibility: 'hidden',
      },
      '& .swiper-pagination-bullet': {
        opacity: 0.9,
      },
      '& .swiper-pagination-bullet-active': {
        opacity: 1,
        background: fade(theme.palette.common.white, 0.9),
      },
      '& .swiper-pagination': {
        [theme.breakpoints.down('xs')]: {
          bottom: 'auto',
          top: `calc( 100% - ${theme.spacing(2.5)}px)`,
        },
      },
    },

    product: {
      cursor: 'pointer',
    },
    // viewAllbtnIcon: {
    //   marginLeft: theme.spacing(1),
    // },
    viewAllbtn: {
      // width: theme.spacing(42.75),
      height: theme.spacing(7),
      background: theme.palette.secondary.main,
      borderRadius: theme.spacing(1),
      padding: '16px 24px',
      textAlign: 'center',
      justifyContent: 'center',
      margin: '0 20px',
      color: 'white',
      fontSize: theme.spacing(2),
      fontWeight: 600,
      marginBottom: theme.spacing(8),
      display: 'flex',
      lineHeight: '150%',
    },
    viewAllbtnIcon: {
      // marginTop: theme.spacing(0.4),
      display: 'flex',
      alignSelf: 'center',
      marginLeft: theme.spacing(1),
    },
    homeBottomContainer: {
      backgroundColor: '#F9FAFB',
      padding: '50px 0',
    },
    homeBottomBox: {
      width: theme.spacing(42.75),
      height: theme.spacing(66.375),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: theme.spacing(3),
      backgroundColor: '#FFFFFF',
      borderRadius: theme.spacing(3),
      // margin: theme.spacing(3),
      margin: '0 auto',
    },
    homeBottomTwoBox: {
      marginTop: theme.spacing(3),
      height: theme.spacing(7),
      border: '1px solid #E5E7EB',
      borderRadius: theme.spacing(1),
      textAlign: 'center',
      padding: theme.spacing(2),
      fontWeight: 600,
      fontSize: 16,
      width: theme.spacing(36.75),
      lineHeight: '150%',
      display: 'flex',
      justifyContent: 'center',
    },
    homeBottomTwoIcon: {
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(0.4),
    },
  }),
)

const Homepage = () => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const { userInfo } = useSelector((state) => state.auth)
  const history = useHistory()
  const [tImage] = useImageTranslation()
  const HomeBottomtext = [
    {
      label: t('footer.whatsapp'),
      icon: VectorIcon,
      toWhatsApp: true,
      number:
        i18n.language === 'zh-HK'
          ? SITE_MATE_DATA.WHATSAPP_HELP_HK
          : i18n.language === 'en'
          ? SITE_MATE_DATA.WHATSAPP_HELP_EN
          : SITE_MATE_DATA.WHATSAPP_HELP_CN,
      // number:
      //   SERVICE_WHATSAPP.split(' ')[0].slice(1, 5) +
      //   SERVICE_WHATSAPP.split(' ')[1] +
      //   SERVICE_WHATSAPP.split(' ')[2],
    },
    {
      label: t('glossary.faq'),
      icon: HelpIcon,
      path: '/faq',
    },
  ]
  const bannerList = [
    // {
    //   path: '/clinic',
    //   bannerSrc: tImage('Chris', 'webp'),
    //   id: 'EH_Hero_Banner_Xmas22Promo_Book_Button',
    //   auth: false,
    // },
    // {
    //   path: '/clinic',
    //   bannerSrc: tImage('cancer_banner', 'webp'),
    //   id: 'EH_Hero_Banner_CancerScreen_Book_Button',
    //   auth: false,
    // },
    {
      // path: `/agreement/${
      //   process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 16 : 8
      // }`,
      path: `/promotions_NEW330`,
      bannerSrc: tImage('program_banner', 'webp'),
      id: 'EH_Hero_Banner_Healthcheck_KnowMore',
      text: t('HomePage.EH_Hero_Banner_Healthcheck_KnowMore'),
      buttonName: 'EH_HP_HeroBanner1',
      buttonId: 'EH_HP_HeroBanner1',
    },
    // {
    //   path: `/agreement/${
    //     process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 14 : 7
    //   }`,
    //   bannerSrc: tImage('Banner2_revamp', 'webp'),
    //   id: 'EH_Hero_Banner_Atome_KnowMore',
    //   text: t('HomePage.EH_Hero_Banner_Atome_KnowMore'),
    // },
  ]

  return (
    <Box position="relative" bgcolor="background.paper">
      <Helmet>
        <meta name="description" content={t('seoDescription.homepage')} />
        <title>{t('seoTitle.homepage')}</title>
      </Helmet>
      <Header />
      <Box p={1.5} pt={1}>
        <Box mb={1.5} mt={3.25} width="100%" overflow="hidden">
          <Suspense fallback={<Loading />}>
            <Swiper
            // slidesPerView={1.12}
            // spaceBetween={10}
            // centeredSlides={true}
            // autoplay={{
            //   delay: 5000,
            //   disableOnInteraction: false,
            // }}
            // className={classes.swiperWrapper}
            // speed={900}
            // loop
            // watchOverflow={true}
            // watchSlidesVisibility={true}
            // initialSlide={0}
            // onSwiper={(swiper) => {
            //   // console.log(swiper.activeIndex)
            // }}
            // onSlideChange={(swiper) => {
            //   // console.log(swiper.activeIndex)
            // }}
            >
              {bannerList?.map((item, index) => (
                <Box key={index}>
                  <SwiperSlide key={index}>
                    <Box
                      onClick={() => {
                        buttonClick(item.buttonName, item.buttonId)
                        history.push(!userInfo && item.auth ? '/signin' : item.path)
                      }}
                    >
                      <img
                        className={classes.homepageBanner}
                        src={item.bannerSrc}
                        id={item.id}
                        alt="homepage banner"
                      />
                      <Box fontWeight={600} mt={1.5} width={340} margin="0 auto">
                        <Box fontSize={14} color="secondary.main">
                          {t('HomePage.latest_offers')}
                        </Box>
                        <Box className={classes.homepageBannerText}>{item.text}</Box>
                      </Box>
                    </Box>
                  </SwiperSlide>
                </Box>
              ))}
            </Swiper>
          </Suspense>
        </Box>
      </Box>
      <Box pt={2} mb={2.5} px={1} borderRadius="24px 24px 24px 24px">
        <Box fontSize="23px" color="#111827" lineHeight="150%" ml={1.5}>
          <Box fontWeight="fontWeightBold" component="span">
            {t('HomePage.hot_Production')}
          </Box>
        </Box>
        {/* <ProductSwiper /> */}
        <ProductSwiper2 />
        <Box
          className={classes.viewAllbtn}
          onClick={() => {
            buttonClick('EH_HP_Product_SeeAll', 'EH_HP_Product_SeeAll')
            history.push('/ProductList')
          }}
          display="flex"
          alignItems="center"
        >
          <Box>{t('common.check_all')}</Box>
          <ViewAllIcon className={classes.viewAllbtnIcon} />
        </Box>
      </Box>
      <Box className={classes.homeBottomContainer}>
        <Box className={classes.homeBottomBox}>
          <img
            className={classes.homeBottomImg}
            src={tImage('home_bottom_img', 'webp')}
            alt="product info banner"
          />
          <Box mt={3} textAlign="center">
            <Box fontSize={26} fontWeight={600} lineHeight="150%">
              {t('HomePage.get_support')}
            </Box>
            <Box mt={2} fontSize={16} fontWeight={400} color="#4B5563">
              {t('HomePage.contact_us')}
            </Box>
          </Box>
          <Box>
            {HomeBottomtext?.map((item, index) => (
              <Box
                className={classes.homeBottomTwoBox}
                key={index}
                onClick={() => {
                  item.toWhatsApp
                    ? buttonClick('EH_HP_WhatsApp', 'EH_HP_WhatsApp')
                    : buttonClick('EH_HP_FAQ', 'EH_HP_FAQ')
                  item.toWhatsApp ? (window.location.href = item.number) : history.push(item.path)
                }}
              >
                <item.icon className={classes.homeBottomTwoIcon} />
                <Box>{item.label}</Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Homepage
